import React from 'react';
import { motion } from 'framer-motion';
import { Card, CardHeader, CardTitle, CardDescription, CardContent } from './ui/card';
import { Button } from './ui/button';
import { ArrowRight } from 'lucide-react';

export default function ServicesDetailed() {
  const scrollToForm = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const services = [
    {
      id: 'roof-repair',
      title: "Roof Repair",
      description: "Expert roof leak repairs, shingle replacement, and maintenance. Fast response to protect your property from further damage.",
      image: "https://customer-assets.emergentagent.com/job_eliteroofing/artifacts/agcxjb7c_Roof%20Repair%20Pic.jpg"
    },
    {
      id: 'roof-replacement',
      title: "Roof Replacement",
      description: "Complete roof replacement with premium materials. Licensed, insured, and warranty-backed installation by experienced professionals.",
      image: "https://customer-assets.emergentagent.com/job_eliteroofing/artifacts/oulm6e53_Roof%20Replacement%20Pic.JPG"
    },
    {
      id: 'emergency-tarp',
      title: "Emergency Tarp",
      description: "24/7 emergency tarp services. Quick response to prevent further damage after storms and secure your property immediately.",
      image: "https://customer-assets.emergentagent.com/job_eliteroofing/artifacts/17ziyxxo_Emergency%20tarp%20pic.jpg"
    },
    {
      id: 'stucco-repairs',
      title: "Stucco Repairs",
      description: "Professional stucco crack repair, patching, and restoration for residential and commercial properties throughout Central Florida.",
      image: "https://customer-assets.emergentagent.com/job_eliteroofing/artifacts/znyxcg33_stucco%20repair%20pic.jpg"
    },
    {
      id: 'exterior-painting',
      title: "Exterior Painting",
      description: "Professional exterior painting with thorough surface prep, premium paints, and a lasting finish that protects and beautifies.",
      image: "https://customer-assets.emergentagent.com/job_eliteroofing/artifacts/mzx9vxd4_Exterior%20Paint%20Pic.jpg"
    },
    {
      id: 'tree-removal',
      title: "Tree Removal Services",
      description: "Safe and professional tree removal and trimming. Protect your property from hazardous or storm-damaged trees.",
      image: "https://customer-assets.emergentagent.com/job_eliteroofing/artifacts/qcziqfst_Tree%20Removal%20pic.jpg"
    }
  ];

  return (
    <section className="bg-white py-16 md:py-24">
      <div className="mx-auto max-w-screen-xl px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5 }}
          className="text-center mb-16"
        >
          <h2 className="text-4xl md:text-5xl font-bold text-slate-900 mb-4">
            Professional Roofing & Exterior Services
          </h2>
          <p className="text-xl text-slate-600">
            Elite Roofing's Team Provides Quality Services Throughout Central Florida
          </p>
        </motion.div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {services.map((service, index) => (
            <motion.div
              key={service.id}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: '-50px' }}
              transition={{ duration: 0.5, delay: index * 0.05 }}
              id={service.id}
            >
              <Card className="h-full overflow-hidden hover:shadow-xl transition-all duration-300 group">
                <div className="aspect-video overflow-hidden">
                  <img 
                    src={service.image} 
                    alt={service.title}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  />
                </div>
                <CardHeader className="p-6">
                  <CardTitle className="text-2xl mb-3 text-slate-900">{service.title}</CardTitle>
                  <CardDescription className="text-slate-600 leading-relaxed mb-4">
                    {service.description}
                  </CardDescription>
                  <Button 
                    onClick={scrollToForm}
                    variant="link"
                    className="text-[hsl(var(--primary))] font-semibold p-0 h-auto hover:gap-2 transition-all group/btn"
                    data-testid={`${service.id}-learn-more`}
                  >
                    Learn More
                    <ArrowRight className="h-4 w-4 ml-1 group-hover/btn:translate-x-1 transition-transform" />
                  </Button>
                </CardHeader>
              </Card>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
